import React from 'react';
import { Mail, Phone, MapPin, Clock, ArrowRight } from 'lucide-react';
import { CONTACT, IMAGES } from '../mock';

const Hero = () => {
  return (
    <section id="home" className="hero-bg" style={{ ['--hero-img']: `url(${IMAGES.hero})` }}>
      {/* Info bar */}
      <div className="info-bar">
        <div className="max-w-[1280px] mx-auto px-6 py-3 flex flex-wrap items-center justify-between gap-4 text-white/90 text-[13px]">
          <div className="flex items-center gap-2"><Mail size={14} /><span>{CONTACT.email}</span></div>
          <div className="flex items-center gap-2"><Phone size={14} /><span>{CONTACT.phone}</span></div>
          <div className="flex items-center gap-2"><MapPin size={14} /><span>{CONTACT.address}</span></div>
          <div className="flex items-center gap-2"><Clock size={14} /><span>{CONTACT.hours}</span></div>
        </div>
      </div>

      {/* Hero content */}
      <div className="max-w-[1280px] mx-auto px-6 py-24 md:py-36 min-h-[520px] flex items-center">
        <div className="max-w-3xl animate-in">
          <p className="font-serif-display italic text-white/95 text-xl md:text-2xl mb-6 leading-relaxed">
            We are leading financial technology solutions providing company<br />
            all over the world doing over 15 years.
          </p>
          <h1 className="font-serif-display text-white text-5xl md:text-7xl font-bold leading-[1.05] mb-10">
            Financial Consulting <br /> Services for you
          </h1>
          <a href="#services" className="pill-btn">
            LEARN MORE <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
